module.exports = __webpack_public_path__ + "img/GppMaybeOutlined.2377ff42.svg";